export default __webpack_public_path__ + "static/media/Andrea Anfuso.9cd71339.jpg";